import { render, staticRenderFns } from "./LogworkRow.vue?vue&type=template&id=056b5f52&scoped=true&"
import script from "./LogworkRow.vue?vue&type=script&lang=ts&"
export * from "./LogworkRow.vue?vue&type=script&lang=ts&"
import style0 from "./LogworkRow.vue?vue&type=style&index=0&id=056b5f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b5f52",
  null
  
)

export default component.exports